"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardSetGlobalId = void 0;
exports.getStandardSetGlobalIds = getStandardSetGlobalIds;
var StandardSetGlobalId;
(function (StandardSetGlobalId) {
    StandardSetGlobalId["CommonCore"] = "CC-CCSS";
    StandardSetGlobalId["TX"] = "TX-TEKS";
})(StandardSetGlobalId || (exports.StandardSetGlobalId = StandardSetGlobalId = {}));
function getStandardSetGlobalIds() {
    return Object.values(StandardSetGlobalId);
}
